<main class="tracking-page">

  <!-- =====================================================
       LOADING
       ===================================================== -->

  <section
    *ngIf="loading"
    class="state-page">

    <div class="loading-card">

      <div class="loading-animation">
        <span></span>
      </div>

      <strong>
        Consultando seu pedido
      </strong>

      <p>
        Estamos buscando o status mais recente.
      </p>

    </div>

  </section>


  <!-- =====================================================
       ERRO
       ===================================================== -->

  <section
    *ngIf="!loading && error"
    class="state-page">

    <div class="error-card">

      <div class="error-icon">
        !
      </div>

      <h2>
        Não foi possível acompanhar
      </h2>

      <p>
        {{ error }}
      </p>

      <button
        type="button"
        (click)="loadOrder()">

        Tentar novamente

      </button>

    </div>

  </section>


  <!-- =====================================================
       CONTEÚDO
       ===================================================== -->

  <ng-container
    *ngIf="!loading && order">


    <!-- =====================================================
         TOPBAR
         ===================================================== -->

    <header class="tracking-topbar">

      <div class="topbar-inner">

        <button
          type="button"
          class="back-button"
          (click)="goToMenu()">

          <span class="back-arrow">
            ←
          </span>

          Voltar ao cardápio

        </button>

      </div>

    </header>


    <!-- =====================================================
         CONTAINER
         ===================================================== -->

    <div class="tracking-container">


      <!-- =====================================================
           IDENTIFICAÇÃO RESTAURANTE
           ===================================================== -->

      <section class="restaurant-heading">

        <div class="restaurant-heading-left">

          <div class="restaurant-logo">

            <img
              *ngIf="order.restaurant.logoUrl"
              [src]="getImageUrl(order.restaurant.logoUrl)"
              [alt]="order.restaurant.name">

            <span
              *ngIf="!order.restaurant.logoUrl">

              {{ order.restaurant.name.charAt(0) }}

            </span>

          </div>


          <div class="restaurant-heading-info">

            <span class="page-kicker">
              ACOMPANHAMENTO DO PEDIDO
            </span>

            <h1>
              {{ order.restaurant.name }}
            </h1>

            <p>
              Pedido #{{ order.id }}
              <span class="dot">•</span>
              {{ formatDate(order.createdAt) }}
            </p>

          </div>

        </div>


        <button
          type="button"
          class="top-refresh-button"
          [disabled]="loading"
          (click)="loadOrder()">

          <span>
            ↻
          </span>

          Atualizar

        </button>

      </section>


      <!-- =====================================================
           STATUS PRINCIPAL
           ===================================================== -->

      <section
        class="status-main-card"
        [class.status-finished]="order.status === 'DELIVERED'"
        [class.status-canceled]="order.status === 'CANCELED'">


        <!-- ÍCONE GRANDE -->

        <div class="status-visual">

          <div class="status-visual-circle">

            <span
              *ngIf="order.status === 'PENDING'"
              class="status-big-icon">
              🧾
            </span>

            <span
              *ngIf="order.status === 'ACCEPTED'"
              class="status-big-icon">
              ✓
            </span>

            <span
              *ngIf="order.status === 'PREPARING'"
              class="status-big-icon">
              👨‍🍳
            </span>

            <span
              *ngIf="order.status === 'READY'"
              class="status-big-icon">
              🍽️
            </span>

            <span
              *ngIf="order.status === 'OUT_FOR_DELIVERY'"
              class="status-big-icon">
              🛵
            </span>

            <span
              *ngIf="order.status === 'DELIVERED'"
              class="status-big-icon">
              ✓
            </span>

            <span
              *ngIf="order.status === 'CANCELED'"
              class="status-big-icon">
              ×
            </span>

          </div>

        </div>


        <!-- TEXTO -->

        <div class="status-main-content">

          <span class="status-label">
            STATUS ATUAL
          </span>

          <h2>
            {{ getStatusLabel(order.status) }}
          </h2>

          <p>
            {{ getStatusDescription(order.status) }}
          </p>


          <div class="status-info-row">

            <div class="status-info-item">

              <div class="status-info-icon">
                🛵
              </div>

              <div>

                <small>
                  Tipo do pedido
                </small>

                <strong>
                  {{ getDeliveryTypeLabel() }}
                </strong>

              </div>

            </div>


            <div class="status-info-item">

              <div class="status-info-icon">
                ◷
              </div>

              <div>

                <small>
                  Situação
                </small>

                <strong>
                  {{ getStatusLabel(order.status) }}
                </strong>

              </div>

            </div>

          </div>

        </div>


        <!-- DECORAÇÃO -->

        <div class="status-decoration">

          <div class="kitchen-illustration">

            <div class="steam steam-one">
              ~
            </div>

            <div class="steam steam-two">
              ~
            </div>

            <div class="pot-lid"></div>

            <div class="pot">
              <div class="pot-handle left"></div>
              <div class="pot-handle right"></div>
            </div>

            <div class="counter-line"></div>

          </div>

        </div>

      </section>


      <!-- =====================================================
           ACOMPANHAMENTO HORIZONTAL
           ===================================================== -->

      <section
        class="progress-card"
        *ngIf="order.status !== 'CANCELED'">


        <div class="section-title">

          <div>

            <span>
              ACOMPANHAMENTO
            </span>

            <h2>
              Acompanhe seu pedido
            </h2>

          </div>

        </div>


        <div class="timeline-scroll">

          <div class="horizontal-timeline">


            <!-- =================================================
                 PEDIDO RECEBIDO
                 ================================================= -->

            <div
              class="timeline-step"
              [class.completed]="isStatusCompleted('PENDING')"
              [class.current]="isCurrentStatus('PENDING')">


              <div class="step-top">

                <div class="step-line step-line-left"></div>

                <div class="step-circle">

                  <span class="step-icon">
                    ▤
                  </span>

                  <span class="step-check">
                    ✓
                  </span>

                </div>

                <div class="step-line step-line-right"></div>

              </div>


              <div class="step-text">

                <strong>
                  Pedido recebido
                </strong>

                <span>
                  Recebemos seu pedido
                </span>

              </div>

            </div>


            <!-- =================================================
                 PEDIDO CONFIRMADO
                 ================================================= -->

            <div
              class="timeline-step"
              [class.completed]="isStatusCompleted('ACCEPTED')"
              [class.current]="isCurrentStatus('ACCEPTED')">


              <div class="step-top">

                <div class="step-line step-line-left"></div>

                <div class="step-circle">

                  <span class="step-icon">
                    ✓
                  </span>

                  <span class="step-check">
                    ✓
                  </span>

                </div>

                <div class="step-line step-line-right"></div>

              </div>


              <div class="step-text">

                <strong>
                  Pedido confirmado
                </strong>

                <span>
                  Restaurante confirmou
                </span>

              </div>

            </div>


            <!-- =================================================
                 PREPARANDO
                 ================================================= -->

            <div
              class="timeline-step"
              [class.completed]="isStatusCompleted('PREPARING')"
              [class.current]="isCurrentStatus('PREPARING')">


              <div class="step-top">

                <div class="step-line step-line-left"></div>

                <div class="step-circle">

                  <span class="step-icon chef-icon">
                    ♨
                  </span>

                  <span class="step-check">
                    ✓
                  </span>

                </div>

                <div class="step-line step-line-right"></div>

              </div>


              <div class="step-text">

                <strong>
                  Em preparo
                </strong>

                <span>
                  Preparando seus itens
                </span>

              </div>

            </div>


            <!-- =================================================
                 PEDIDO PRONTO
                 ================================================= -->

            <div
              class="timeline-step"
              *ngIf="shouldShowReadyStatus()"
              [class.completed]="isStatusCompleted('READY')"
              [class.current]="isCurrentStatus('READY')">


              <div class="step-top">

                <div class="step-line step-line-left"></div>

                <div class="step-circle">

                  <span class="step-icon">
                    ♨
                  </span>

                  <span class="step-check">
                    ✓
                  </span>

                </div>

                <div class="step-line step-line-right"></div>

              </div>


              <div class="step-text">

                <strong>
                  Pedido pronto
                </strong>

                <span
                  *ngIf="order.deliveryType === 'PICKUP'">

                  Pronto para retirada

                </span>

                <span
                  *ngIf="order.deliveryType !== 'PICKUP'">

                  Preparo finalizado

                </span>

              </div>

            </div>


            <!-- =================================================
                 ENTREGA
                 ================================================= -->

            <div
              class="timeline-step"
              *ngIf="shouldShowDeliveryStatus()"
              [class.completed]="isStatusCompleted('OUT_FOR_DELIVERY')"
              [class.current]="isCurrentStatus('OUT_FOR_DELIVERY')">


              <div class="step-top">

                <div class="step-line step-line-left"></div>

                <div class="step-circle">

                  <span class="step-icon scooter-icon">
                    ➜
                  </span>

                  <span class="step-check">
                    ✓
                  </span>

                </div>

                <div class="step-line step-line-right"></div>

              </div>


              <div class="step-text">

                <strong>
                  Saiu para entrega
                </strong>

                <span>
                  Seu pedido está a caminho
                </span>

              </div>

            </div>


            <!-- =================================================
                 FINALIZADO
                 ================================================= -->

            <div
              class="timeline-step"
              [class.completed]="isStatusCompleted('DELIVERED')"
              [class.current]="isCurrentStatus('DELIVERED')">


              <div class="step-top">

                <div class="step-line step-line-left"></div>

                <div class="step-circle">

                  <span class="step-icon">
                    ⌂
                  </span>

                  <span class="step-check">
                    ✓
                  </span>

                </div>

                <div class="step-line step-line-right"></div>

              </div>


              <div class="step-text">

                <strong>
                  Pedido finalizado
                </strong>

                <span>
                  Pedido concluído
                </span>

              </div>

            </div>


          </div>

        </div>

      </section>


      <!-- =====================================================
           PEDIDO
           ===================================================== -->

      <section class="order-card">


        <div class="order-card-heading">

          <div>

            <span>
              SEU PEDIDO
            </span>

            <h2>
              Seu pedido
            </h2>

          </div>


          <div class="delivery-badge">

            {{ getDeliveryTypeLabel() }}

          </div>

        </div>


        <!-- =====================================================
             ITENS
             ===================================================== -->

        <div class="order-items">


          <article
            class="order-item"
            *ngFor="let item of order.items">


            <div class="item-image">

              <img
                *ngIf="item.product.imageUrl"
                [src]="getImageUrl(item.product.imageUrl)"
                [alt]="item.product.name">


              <span
                *ngIf="!item.product.imageUrl"
                class="item-placeholder">

                {{ item.product.name.charAt(0) }}

              </span>


              <span class="item-quantity">

                {{ item.quantity }}x

              </span>

            </div>


            <div class="item-information">

              <strong>
                {{ item.product.name }}
              </strong>


              <p
                *ngIf="item.product.description">

                {{ item.product.description }}

              </p>


              <div
                class="item-note"
                *ngIf="item.notes">

                <span>
                  ✎
                </span>

                {{ item.notes }}

              </div>

            </div>


            <strong class="item-price">

              {{
                formatMoney(
                  +item.unitPrice *
                  item.quantity
                )
              }}

            </strong>

          </article>


        </div>


        <!-- =====================================================
             VALORES
             ===================================================== -->

        <div class="price-summary">


          <div
            *ngIf="order.subtotal !== undefined">

            <span>
              Subtotal
            </span>

            <strong>
              {{ formatMoney(order.subtotal) }}
            </strong>

          </div>


          <div
            *ngIf="order.deliveryFee !== undefined">

            <span>
              Taxa de entrega
            </span>

            <strong>
              {{ formatMoney(order.deliveryFee) }}
            </strong>

          </div>


          <div class="total-row">

            <span>
              Total
            </span>

            <strong>
              {{ formatMoney(order.total) }}
            </strong>

          </div>

        </div>

      </section>


      <!-- =====================================================
           AÇÕES
           ===================================================== -->

      <section class="tracking-actions">


        <button
          type="button"
          class="refresh-button"
          [disabled]="loading"
          (click)="loadOrder()">

          <span>
            ↻
          </span>

          Atualizar status

        </button>


        <button
          type="button"
          class="menu-button"
          (click)="goToMenu()">

          Voltar ao cardápio

        </button>


      </section>


    </div>

  </ng-container>

</main>